import { Fonts } from 'src/com/sixdee/crbtportal/utils/resources/fonts';
import { Colors } from 'src/com/sixdee/crbtportal/utils/resources/colors';
import { UIComponentCSSStyle, UIComponentCSSStyleImpl } from '../../toolkit/uicomponentcss';


export interface LandingPageCSSStyle extends UIComponentCSSStyle
{
    getTitleCSSStyle():object;
    getInnerWrapperCSSStyle():object;
    getLogoWrapperCSSStyle():object;
    getLanguageCSSStyle():object;
    getToneDetailsDivCSSStyle(): object;
    getToneNameCSSStyle(): object;
    getArtistNameCSSStyle(): object;
    getTermsConditionCSSStyle():object;
    getRowDivCSSStyle():object;
    getAnchorCSSStyle(): object;

}

export class LandingPageCSSStyleImpl extends UIComponentCSSStyleImpl implements LandingPageCSSStyle
{
    getWrapperCSSStyle(): object
    {
        return {
            width: "100%",
            // justifyContent:'center',
            marginTop: "10px",
            flexDirection: "row",
            flexFlow: "row wrap",
            display:"flex"
            // textAlign: "center",
            // alignItems:'center'

        };
    }

    getTermsConditionCSSStyle(): object {
        return{
            display: "inline-block",
            // textAlign: this.getContext().getUserContext().getLanguage() === LanguageConst.ENGLISH ? "left" : "right",
            height: "20px",
            letterSpacing: 0,
            fontSize: this.getResources().getFont(Fonts.h7),
            color:'#231F20',
            fontWeight:'500',
            fontFamily:this.getResources().getFontFamily(),
            lineHeight: "20px",
            paddingLeft: "10px",
            // flex: 2,
            // paddingTop:'5px',
            // marginLeft:'5px',
        };
    }
    getRowDivCSSStyle(): object 
    {
        return {
            marginTop: "0px",
            width:'100%',
            display: "flex",
            justifyContent:'flex-start',
            position: "relative",
            alignItems:'center',
            flexDirection:"row",
            flexFlow: "row wrap",
        };
    }
    getLogoWrapperCSSStyle():object
    {
        return{
        //   height:'100%',justifyContent:'flex-start',
            // borderBottom: "1px solid " + this.getResources().getColor(Colors.color_3),

        };
    }

    getLanguageCSSStyle():object
    {
        return{
            width:'80%',height:'100%',alignItems:'right',marginLeft:"200px"
            // borderBottom: "1px solid " + this.getResources().getColor(Colors.color_3),
        };
    }
    getInnerWrapperCSSStyle():object
    {
        return{
            width:'100%',
            height:'100%',
            justifyContent:'center',
        };
    }
    getToneDetailsDivCSSStyle(): object 
    {
        return {
            // paddingTop: "8px",
            // borderRadius:'0px 0px 8px 8px',
            // paddingLeft:'20px',
            // top:'-150px',
            // left:'0%',
            // position:'relative',
            // paddingRight:'10px',
            // alignItems:'left',
            // height: "150px",
            // width: "100%",
            // // opacity:'5%',
            // background:"rgba(0,0,0,0.5)",
        };
    }

    getToneNameCSSStyle(): object {
       return {
        // width: "100%",
        // height: "30px",
        // minWidth:'50px',
        // fontWeight: "900",
        // letterSpacing: 0,
        fontFamily: this.getResources().getFontFamily(),
        // fontSize: this.getResources().getFont(Fonts.h9),
        color:this.getResources().getColor(Colors.color_5),
        // lineHeight: "30px",
        // textAlign: "left",
        // overflow: 'hidden',
        // textOverflow: 'ellipsis'
       };
    }

    getArtistNameCSSStyle(): object {
        return {
            // width: "100%",
            // minWidth:'50px',
            // height: "20px",
            fontFamily: this.getResources().getFontFamily(),
            color:this.getResources().getColor(Colors.color_5),
            // fontSize: this.getResources().getFont(Fonts.h7),
            // letterSpacing: 0,
            // lineHeight: "20px",
            // textAlign: "left",
            // overflow: 'hidden',
            // fontWeight:300,
            // textOverflow: 'ellipsis'
        };
    }
    getTitleCSSStyle(): object 
    {
        return {
            display: "flex",
            textAlign: "center",
            justifyContent: 'flex-start',
            height: "30px",
            fontWeight: 800,
            letterSpacing: 0,
            textShadow: "0 1px 1px 0 rgba(0,0,0,0.18)",
            fontSize: this.getResources().getFont(Fonts.h11),
            color: this.getResources().getColor(Colors.color_6),
            fontFamily: this.getResources().getFontFamily(),
            lineHeight: "30px",
            paddingTop: '70px',  
            marginBottom: '50px',
            marginLeft: '0px',
        };
    } 

    getAnchorCSSStyle(): object {
        return {
                    lineHeight: '20px', 
                    letterSpacing: "-0.08px",
                    fontFamily: this.getResources().getFontFamily(), 
                    fontSize: this.getResources().getFont(Fonts.h6), 
                    color: this.getResources().getColor(Colors.color_7), 
                };
    }
}



// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/components/landingpage/landingcss.tsx